import RegisterPhdPage from "./RegisterPhDPage";
export default RegisterPhdPage;
